import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Btn from '../../ds/atoms/btn';

class BudgetBox extends React.Component {
  constructor(props) {
    super(props);
    this.showInfoModal = this.showInfoModal.bind(this);
    this.onShowSaveModal = this.onShowSaveModal.bind(this);
  }

  render() {
    return (
            <div className={'border blue-style p-4 mb-4 mw-300'}>
              <div className="text-center">
                <h2 className={'BudgetTitle'}>
                  {this.context.t('Need more time?')}
                </h2>
              </div>
              <div className="text-center font-weight-bold">
                <p className="py-1">
                  {this.context.t('We keep for you the same price for 24 hrs.')}
                </p>
                <p>
                  {this.context.t('No questions asked!')}
                </p>
                <Btn variant="link"
                     onClick={this.showInfoModal}>
                  <span className={'capitalize'}>{this.context.t('See Terms and Conditions')}</span>
                </Btn>
              </div>
              <div className="text-center py-2">
                <Btn variant="primary-solid"
                     onClick={this.onShowSaveModal}>
                  <span className={'text-uppercase'}>{this.context.t('Lock this price')}</span>
                </Btn>
              </div>
            </div>
    );
  }

  showInfoModal(ev) {
    this.props.onShowInfo(ev);
  }

  onShowSaveModal(ev) {
    this.props.onShowSave(ev);
  }
}

BudgetBox.propTypes = {
  onShowInfo:
  PropTypes.func.isRequired,
  onShowSave:
  PropTypes.func.isRequired,
};
BudgetBox.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default connect((state) => (
  {
    lang: state.i18nState.lang,
  }
))(BudgetBox);
